@let data = model();

@switch (column().key) {
  @case (getColumnKey('change')) {
    <div class="flex flex-row">
      <div class="w-1/5 text-right">{{ data.quantityBeforeChange }}</div>
      <div class="w-1/5 text-center">{{ data.change < 1 ? '-' : '+' }}</div>
      <div class="w-1/5 text-right font-bold">
        @if (data.change < 0) {
          <span class="text-red-600">{{ data.absoluteChange }}</span>
        } @else {
          <span class="text-green-600">{{ data.absoluteChange }}</span>
        }
      </div>
      <div class="w-1/5 text-center">=</div>
      <div class="w-1/5 text-right">{{ data.quantityAfterChange }}</div>
    </div>
  }

  @case (getColumnKey('reason')) {
    <app-warehouse-product-quantity-history-reason-type [type]="data.reason" />
  }

  @case (getColumnKey('receipt')) {
    @if (isNotNil(data.receipt)) {
      {{ data.receipt.number }}
    } @else {
      <app-no-data />
    }
  }

  @case (getColumnKey('release')) {
    @if (isNotNil(data.release)) {
      {{ data.release.number }}
    } @else {
      <app-no-data />
    }
  }

  @case (getColumnKey('restock')) {
    @if (isNotNil(data.restock)) {
      {{ data.restock.number }}
    } @else {
      <app-no-data />
    }
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="column().key" />
  }
}
